import { DEALERS_INSIGHTS_LEVELS } from '../redux/level/constants';

import { DEALERS_INSIGHTS_TIME_DIVISIONS } from './dealersInsights.api';

/**
 *
 * @typedef {Object} DealersInsightsCacheKeyProps
 * @property {string} featurePrefix
 * @property {'month'|'year'} selectedTimeDivisionFilter
 * @property {number} selectedMonth
 * @property {number} selectedYear
 * @property {import('../../modules/dealersInsights/redux/level/reducer.defaultState').DealerInsightsLevel} level
 * @property {string} dealerId
 */

/**
 * @param {DealersInsightsCacheKeyProps} param0
 */
export const dealerInsightsDefaultCacheKey = ({
  featurePrefix,
  selectedTimeDivisionFilter,
  selectedMonth,
  selectedYear,
  level,
  dealerId,
}) => {
  // named spaced cacheing is very helpful for debugging
  let cacheKey = '';

  // current level
  if (level === DEALERS_INSIGHTS_LEVELS.DEALER) {
    cacheKey += `dealerId--${dealerId}--`;
  } else {
    cacheKey += 'network--';
  }

  // feature name
  cacheKey += `${featurePrefix}--`;

  // time division and date
  if (selectedTimeDivisionFilter === DEALERS_INSIGHTS_TIME_DIVISIONS.YEAR) {
    cacheKey += `${selectedTimeDivisionFilter}--${selectedYear}`;
  } else {
    cacheKey += `${selectedTimeDivisionFilter}--${selectedYear}-${selectedMonth}`;
  }
  return cacheKey;
};
